export enum EnvironmentTypeEnum {
  DEV = 1,
  PROD,
}

export interface TenantSettings {
  id: number;
  tenantName: string;
  ownerId: string;
  environmentTypeId: EnvironmentTypeEnum;
  url: string;
  tagManagerId: string;
}

export interface Settings {
  tenantSettings: TenantSettings;
  isFeedbackEnabled: boolean;
}

export class PaginatorSettings {
  static readonly DEFAULT_PAGE_SIZE: number = 15;
  static readonly DEFAULT_CURRENT_PAGE: number = 0;
  static readonly DEFAULT_PAGINATION_SORT_ORDER: number = 1;
}

export enum apiRoutes {
  DEFAULT_PREFIX_ROUTE = '/api',
  ITEM = 'item',
  USER_GROUPS = 'usersgroups',
}
